var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('PageTitle',{attrs:{"customField":_vm.user.team_name,"title":`Past Teams`}}),_c('PastTournamentsTable',{attrs:{"tournaments":_vm.tournaments,"loading":_vm.loading,"headers":_vm.headers,"columns":_vm.columns,"message":_vm.message,"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }